import { CustomLocationField } from '@vyce/core/src/api/types';

export const prepareCustomForDefault = (data: CustomLocationField[]) => {
  if (!data) return {};
  return data.reduce((sum, curr) => {
    sum = { ...sum, [curr.system_name]: curr.value };
    return sum;
  }, {});
};
